import { camelize } from 'humps';
import { pathOr } from 'ramda';
import { createSelector } from 'reselect';

import { selectors } from '@ezugi/bootstrap';

const gameName = import.meta.env.VITE_GAME_NAME;

const { configSelector } = selectors;

/**
 * Toggle Odd & Even bets
 * Also need to adjust the betting grid based on the these bets
 * Disabled by default.
 */
export const showOddEvenSelector = createSelector(
  configSelector,
  pathOr(false, [ camelize(gameName), 'oddEven' ])
);
